import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "groupLevelInformation__levelDetails" }
const _hoisted_2 = { class: "levelDetails__desctiption" }
const _hoisted_3 = { class: "levelDetails__rhythm" }
const _hoisted_4 = { class: "levelDetails__frequency" }
const _hoisted_5 = { class: "levelDetails__isForMeIf" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Es para vos si... ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.level.description), 1),
    _createElementVNode("p", _hoisted_3, "Ritmo: " + _toDisplayString(_ctx.level.rhythm), 1),
    _createElementVNode("p", _hoisted_4, "Frecuencia: " + _toDisplayString(_ctx.level.frequency), 1),
    _createElementVNode("ul", _hoisted_5, [
      _hoisted_6,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.level.itIsForMeIf, (reason) => {
        return (_openBlock(), _createElementBlock("li", {
          key: reason,
          class: "isForMeIf__item"
        }, _toDisplayString(reason), 1))
      }), 128))
    ])
  ]))
}